import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

export const usePdpSellerReviewsVariant = (): boolean => {
    const { isPdpSellerReviewsVariant } = useServerVarsContext();
    return !!isPdpSellerReviewsVariant;
};
